import { useTranslation } from 'react-i18next';
import { Locale } from '../enums';
import { useRoute } from './useRoute';
import { useEffect } from 'react';

export const useLanguage = () => {
  const { i18n } = useTranslation();
  const { queries } = useRoute();
  const lang = queries.get('lang');

  const updateLocale = () => {
    const lang = i18n.language === Locale.EN ? Locale.MY : Locale.EN;
    i18n.changeLanguage(lang);
  };

  useEffect(() => {
    if (lang) {
      i18n.changeLanguage(lang);
    }
  }, [lang]);

  return {
    locale: i18n.language,
    updateLocale,
  };
};
